import { Button } from '@mui/material';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Suspense } from 'react';
import { PageHeader } from '@components/PageHeader';

import PatientList from './components/PatientList';

const PatientsHeader = () => {
  const navigate = useNavigate();

  return (
    <PageHeader
      eyebrow="Clinical records"
      title="Patients"
      description="Manage patient records, clinical context, phenotypes, and associated samples."
      actions={
        <Button
          onClick={() => navigate('create')}
          variant="contained"
          startIcon={<Plus size={17} />}
        >
          Create Patient
        </Button>
      }
    />
  );
};

const Patients = () => (
  <main style={{ width: '100%', maxWidth: '1600px', margin: '0 auto' }}>
    <PatientsHeader />
    <Suspense fallback={<div>Loading...</div>}>
      <PatientList />
    </Suspense>
  </main>
);

export default Patients;
